//@flow
import { PlatformOS } from "./Platform";
import { StatusBar } from "react-native";

let statusBarHeight = PlatformOS.iOS ? 20 : StatusBar.currentHeight;

export { statusBarHeight };
